import { AnimatePresence, motion } from 'framer-motion'
import { useEffect } from 'react'

import { usePlanStore } from '../store/planStore'

export function Toast() {
  const toast = usePlanStore((s) => s.toast)
  const dismiss = usePlanStore((s) => s.dismissToast)

  useEffect(() => {
    if (!toast) return undefined
    const timer = setTimeout(dismiss, 3600)
    return () => clearTimeout(timer)
  }, [toast, dismiss])

  return (
    <AnimatePresence>
      {toast && (
        <motion.div
          key={toast.id}
          className={`toast toast--${toast.tone}`}
          initial={{ opacity: 0, y: 18, scale: 0.96 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 10, scale: 0.98 }}
          transition={{ type: 'spring', stiffness: 460, damping: 32 }}
          role="status"
          aria-live="polite"
          onClick={dismiss}
        >
          {toast.message}
        </motion.div>
      )}
    </AnimatePresence>
  )
}
